export const getPersonalityType = (trait, t) => {
  switch (trait.toUpperCase()) {
    case "E":
      return t("dashboard.personality_trait_type.e");
    case "I":
      return t("dashboard.personality_trait_type.i");
    case "S":
      return t("dashboard.personality_trait_type.s");
    case "N":
      return t("dashboard.personality_trait_type.n");
    case "T":
      return t("dashboard.personality_trait_type.t");
    case "F":
      return t("dashboard.personality_trait_type.f");
    case "J":
      return t("dashboard.personality_trait_type.j");
    case "P":
      return t("dashboard.personality_trait_type.p");

    default:
      throw new Error(`Invalid trait: ${trait}`);
  }
};

export const opposites = [
  { key: "S", opposite: "N" },
  { key: "E", opposite: "I" },
  { key: "T", opposite: "F" },
  { key: "J", opposite: "P" },
];

export const getBigFiveTraitType = (trait, t) => {
  switch (trait.toUpperCase()) {
    case "N":
      return t("dashboard.bigfive_trait_type.n");
    case "E":
      return t("dashboard.bigfive_trait_type.e");
    case "O":
      return t("dashboard.bigfive_trait_type.o");
    case "C":
      return t("dashboard.bigfive_trait_type.c");
    case "A":
      return t("dashboard.bigfive_trait_type.a");
    default:
      throw new Error(`Invalid trait: ${trait}`);
  }
};

export const getOppositeTrait = (trait, t) => {
  switch (trait) {
    case "Introverted":
      return t("dashboard.personality_trait_type.e");
    case "Extroverted":
      return t("dashboard.personality_trait_type.i");
    case "Sensing":
      return t("dashboard.personality_trait_type.n");
    case "Intuition":
      return t("dashboard.personality_trait_type.s");
    case "Thinking":
      return t("dashboard.personality_trait_type.f");
    case "Feeling":
      return t("dashboard.personality_trait_type.t");
    case "Judging":
      return t("dashboard.personality_trait_type.p");
    case "Perceiving":
      return t("dashboard.personality_trait_type.j");
    case "I":
      return t("dashboard.personality_trait_type.e");
    case "E":
      return t("dashboard.personality_trait_type.i");
    case "S":
      return t("dashboard.personality_trait_type.n");
    case "N":
      return t("dashboard.personality_trait_type.s");
    case "T":
      return t("dashboard.personality_trait_type.f");
    case "F":
      return t("dashboard.personality_trait_type.t");
    case "J":
      return t("dashboard.personality_trait_type.p");
    case "P":
      return t("dashboard.personality_trait_type.j");
    default:
      return null;
  }
};

export const getTraitFromEnglishCode = (trait, t) => {
  switch (trait) {
    case "Introverted":
      return t("dashboard.personality_trait_type.i");
    case "Extroverted":
      return t("dashboard.personality_trait_type.e");
    case "Sensing":
      return t("dashboard.personality_trait_type.s");
    case "Intuition":
      return t("dashboard.personality_trait_type.n");
    case "Thinking":
      return t("dashboard.personality_trait_type.t");
    case "Feeling":
      return t("dashboard.personality_trait_type.f");
    case "Judging":
      return t("dashboard.personality_trait_type.j");
    case "Perceiving":
      return t("dashboard.personality_trait_type.p");

    case "I":
      return t("dashboard.personality_trait_type.i");
    case "E":
      return t("dashboard.personality_trait_type.e");
    case "S":
      return t("dashboard.personality_trait_type.s");
    case "N":
      return t("dashboard.personality_trait_type.n");
    case "T":
      return t("dashboard.personality_trait_type.t");
    case "F":
      return t("dashboard.personality_trait_type.f");
    case "J":
      return t("dashboard.personality_trait_type.j");
    case "P":
      return t("dashboard.personality_trait_type.p");
    default:
      return null;
  }
};

export const getTraitColor = (trait, t) => {
  switch (trait) {
    case "Introverted":
    case "Extroverted":
    case "Neuroticism":
      return "teal";
    case "Sensing":
    case "Intuition":
    case "Extraversion":
      return "purple";
    case "Thinking":
    case "Feeling":
    case "Openness":
      return "green";
    case "Judging":
    case "Perceiving":
    case "Conscientiousness":
      return "red";
    default:
      return "gray"; // Default color for any unexpected trait
  }
};

export const getTraitTitle = (trait, t) => {
  switch (trait) {
    case "Introverted":
    case "Extroverted":
      return t("report.personality.enerfy_focus");
    case "Sensing":
    case "Intuition":
      return t("report.personality.information_processing");
    case "Thinking":
    case "Feeling":
      return t("report.personality.decision_making");
    case "Judging":
    case "Perceiving":
      return t("report.personality.outside_world_approch");
    default:
      return "";
  }
};

export const getTailwindColorClasses = (color) => {
  switch (color) {
    case "teal":
      return {
        bgColor: "bg-teal-500",
        textColor: "text-teal-800",
        subTextColor: "text-teal-700",
        bgLightColor: "bg-teal-200",
        progressBarColor: "bg-teal-600",
        borderColor: "border-teal-600",
      };
    case "purple":
      return {
        bgColor: "bg-purple-500",
        textColor: "text-purple-800",
        subTextColor: "text-purple-700",
        bgLightColor: "bg-purple-200",
        progressBarColor: "bg-purple-600",
        borderColor: "border-purple-600",
      };
    case "green":
      return {
        bgColor: "bg-green-500",
        textColor: "text-green-800",
        subTextColor: "text-green-700",
        bgLightColor: "bg-green-200",
        progressBarColor: "bg-green-600",
        borderColor: "border-green-600",
      };
    case "red":
      return {
        bgColor: "bg-red-500",
        textColor: "text-red-800",
        subTextColor: "text-red-700",
        bgLightColor: "bg-red-200",
        progressBarColor: "bg-red-600",
        borderColor: "border-red-600",
      };
    default:
      return {
        bgColor: "bg-gray-500",
        textColor: "text-gray-800",
        subTextColor: "text-gray-700",
        bgLightColor: "bg-gray-200",
        progressBarColor: "bg-gray-600",
        borderColor: "border-gray-600",
      };
  }
};
